/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { VersionDto } from './version.dto';

export const VersionMapper = entity<VersionDto>();
